import React from "react";
import { Table, Pagination, CircularProgress } from "@ann/web-components";
import Filters from "../Filters";
import { TableWrapper, TableContainer, PaginationWrapper, LoadingContainer } from "./UserTableSection.styled";

const UserTableSection = ({
  tableData,
  headers,
  onSelectionChange,
  currentPage,
  itemsPerPage,
  onItemsPerPageChange,
  onPageChange,
  totalItems,
  totalPages,
  loading,
  onSortChange,
  onOrderChange,
  selectedSortOption,
  orderDirection,
  onSearchChange,
}) => {
  return (
    <TableWrapper>
      <TableContainer>
        <Filters
          onSortChange={onSortChange}
          onOrderChange={onOrderChange}
          selectedSortOption={selectedSortOption}
          orderDirection={orderDirection}
          onSearchChange={onSearchChange}
          loading={loading}
        />
        {loading ? (
          <LoadingContainer>
            <CircularProgress size="xl" />
          </LoadingContainer>
        ) : (
          <Table
            selectable
            data={tableData}
            headers={headers}
            mode="table"
            showActions={false}
            onSelectionChange={onSelectionChange}
          />
        )}
      </TableContainer>
      <PaginationWrapper>
        <Pagination
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          onItemsPerPageChange={onItemsPerPageChange}
          onPageChange={onPageChange}
          totalItems={totalItems}
          totalPages={totalPages}
          disabled={loading}
        />
      </PaginationWrapper>
    </TableWrapper>
  );
};

export default UserTableSection;

